/**
* *************************************************************************
*  ADOBE CONFIDENTIAL
*  ___________________
* 
*   Copyright 2017 Adobe
*   All Rights Reserved.
* 
*  NOTICE:  All information contained herein is, and remains
*  the property of Adobe and its suppliers, if any. The intellectual
*  and technical concepts contained herein are proprietary to Adobe
*  and its suppliers and are protected by all applicable intellectual
*  property laws, including trade secret and copyright laws.
*  Dissemination of this information or reproduction of this material
*  is strictly forbidden unless prior written permission is obtained
*  from Adobe.
* **************************************************************************
* 
**/'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatMessageInterpolator = undefined;

var _intlMessageformat = require('intl-messageformat');

var _intlMessageformat2 = _interopRequireDefault(_intlMessageformat);

var _intlFormatCache = require('intl-format-cache');

var _intlFormatCache2 = _interopRequireDefault(_intlFormatCache);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formatMessageInterpolator = exports.formatMessageInterpolator = function formatMessageInterpolator(message, values, locale, formats) {
  var formattedMessage = void 0;

  try {
    var formatter = (0, _intlFormatCache2.default)(_intlMessageformat2.default);

    formattedMessage = formatter(message, locale, formats).format(values);
  } catch (error) {
    console.error('Failed to format message: "' + message + '" of locale: "' + locale + '"\n' + error);
  }

  return formattedMessage || message;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@exc-ui/exc-sdk/dist/production/localization/interpolator/FormatMessageInterpolator.js
// module id = 721
// module chunks = 0